import React from 'react'
import Card from './styled-components/Card'
import HeaderText from './styled-components/HeaderText'
import HeaderTextSmall from './styled-components/HeaderTextSmall'
import { ButtonPrimaryWide } from './styled-components/Button'
import { AnovaLogoSmall } from './AnovaLogo'
import TextColumn from './styled-components/TextColumn'
import ButtonColumn from './styled-components/ButtonColumn'
import logInGoogleUser from '../logInGoogleUser'
import { analyticsPage } from '../analytics'

const ContinueWithGoogle = () => {
  analyticsPage('ALI Log In - Account Already Exists With Google')

  return (
    <Card data-continue-with-google>
      <div>
        <AnovaLogoSmall />
      </div>

      <TextColumn>
        <HeaderText>Continue With Google</HeaderText>
        <HeaderTextSmall>
          It looks like you already have an Anova account. Please continue with Google.
        </HeaderTextSmall>
      </TextColumn>

      <ButtonColumn>
        <ButtonPrimaryWide
          onClick={logInGoogleUser}
          data-continue-button>
          CONTINUE
        </ButtonPrimaryWide>
      </ButtonColumn>
    </Card>
  )
}

export default ContinueWithGoogle
